
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class PsBizTypesGrid extends Serenity.EntityGrid<PsBizTypesRow, any> {
        protected getColumnsKey() { return PsBizTypesColumns.columnsKey; }
        protected getDialogType() { return PsBizTypesDialog; }
        protected getIdProperty() { return PsBizTypesRow.idProperty; }
        protected getInsertPermission() { return PsBizTypesRow.insertPermission; }
        protected getLocalTextPrefix() { return PsBizTypesRow.localTextPrefix; }
        protected getService() { return PsBizTypesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}